<!-- Energy widget version: 1.0 -->
<script lang="ts">
	import EmEnergyHeatmap from 'src/components/EnergyMonitoring/sections/EmEnergyHeatmap.svelte';
	import EmEnergyHeatmapMinimal from 'src/components/EnergyMonitoring/sections/EmEnergyHeatmapMinimal.svelte';
	import { Container } from '@Shelly/shelly-design-system';
	import { getControlsForHeatmapConfig } from '../../../../dash-energy-period';
	import { normalizeEnergyConfig, normalizeHeatmapMetric } from '../../../../dash-energy-helpers';
	import type { DashEnergyWidgetConfig } from '../../../../dash-energy-types';

	export let energyConfig: DashEnergyWidgetConfig<'dashEnergyHeatmap'> | undefined;
	export let staticPreview = false;
	export let widgetId = '';
	export let widgetTitle = '';

	$: config = normalizeEnergyConfig('dashEnergyHeatmap', energyConfig);
	$: controls = getControlsForHeatmapConfig();
	$: metric = normalizeHeatmapMetric(config);
</script>

<Container type="glass" noScroll fullHeight>
	{#if config.heatmapVariant === 'minimal'}
		<EmEnergyHeatmapMinimal
			{staticPreview}
			{metric}
			{widgetTitle}
			scope={config.heatmapScope}
			roomId={config.roomId}
			deviceId={config.deviceId}
		/>
	{:else}
		<EmEnergyHeatmap
			embedded
			{staticPreview}
			{metric}
			{controls}
			{widgetId}
			{widgetTitle}
			scope={config.heatmapScope}
			roomId={config.roomId}
			deviceId={config.deviceId}
			showMetricToggle={false}
			showPeriodTotal={config.showPeriodTotal !== false}
		/>
	{/if}
</Container>
